import OrderEditScreenComponent from './OrderEditScreenComponent';
import { select } from '../../../store/store';
import { iRootDispatch, iRootState } from '../../../store/store';
import { RouteComponentProps, withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    COSOrdersStore,
    acquireLockPayload,
    sendOrderPayload
} from '../../../store/models/COSOrdersModel';
import {
    OrderEditFormData,
    OrderEditFormDataKeys,
} from '../../components/order-edit-form/OrderEditForm';
import { PATH_ORDERS } from '../../../constants/routerPaths';

interface OrderEditScreenStateProps {
    orderId?: string;
}

interface OrderEditScreenDispatchProps {
    acquireLock?: (payload: acquireLockPayload) => Promise<void>;
    singleById?: (id?: string) => Promise<OrderEditFormData | undefined>;
    //
    fakeOrderSave?: (id?: string) => Promise<void>;
    sendOrder?: (payload: sendOrderPayload) => Promise<void>

}

const selection = () => select((_models) => ({}));

const mapStateToProps = (
    state: iRootState,
    ownProps: RouteComponentProps<{ orderId: string }>
): OrderEditScreenStateProps => ({
    orderId: ownProps?.match?.params?.orderId,
    //
    ...selection()(state),
});

const mapDispatch = (_dispatch: iRootDispatch, _ownDispatch: OrderEditScreenDispatchProps) =>
    ({
        sendOrder: _dispatch.COSOrders.sendOrder,
        acquireLock: _dispatch.COSOrders.acquireLock,
        //
        singleById: (id?: string) =>
            // @ts-ignore
            _dispatch.COSOrders.singleByIdWithKeys<OrderEditFormData>({
                id: id,
                keys: OrderEditFormDataKeys,
            }),
        //
        fakeOrderSave: async (id?: string) => {
            await COSOrdersStore.update(id, {
                state: 'SendingInProgress',
                draftCloseDeadline: new Date(),
            });
            //
            _dispatch.nav.push(PATH_ORDERS);
        },
        //
        ..._ownDispatch,
    } as OrderEditScreenDispatchProps);

type connectedProps = OrderEditScreenStateProps & ReturnType<typeof mapDispatch>;
export type OrderEditScreenProps = connectedProps;

export const OrderEditScreen = withRouter(
    connect(mapStateToProps, mapDispatch as any)(OrderEditScreenComponent)
);
